import { render, staticRenderFns } from "./PricesImportInClinic.vue?vue&type=template&id=18c18e78&scoped=true"
import script from "./PricesImportInClinic.vue?vue&type=script&lang=js"
export * from "./PricesImportInClinic.vue?vue&type=script&lang=js"
import style0 from "./PricesImportInClinic.vue?vue&type=style&index=0&id=18c18e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c18e78",
  null
  
)

export default component.exports